module.exports = __webpack_public_path__ + "static/fonts/355CC9_1_0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_1_0.eot
// module id = 15
// module chunks = 0